import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '@/helpers/ApiClient';

export const iconService = {
    getIcons,
    deleteIcon,
    addIcon,
    updateIcon,
    getIconByCategory
}

function getIcons() {
    return apiClient.get(`/product_picto`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function getIconByCategory(category) {
    return apiClient.get(`/product_picto`, {
        headers: authHeader(),
        params: { category }
    })
    .then((response) => {
        return response.data;
    })
    .catch((error) => handleError(error));
}

function deleteIcon(icon) {
    return apiClient.delete(`/product_picto/${icon.pictoId}`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function updateIcon(pictoId, payload) {
    return apiClient.patch(`/product_picto/${pictoId}`, payload, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function addIcon(icon) {
    return apiClient.post(`/product_picto`, icon, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}
